/** GridDataFormater provides the format methods for ag-grid cells*/

class GridDataFormater {
    static formatPercentage(params) {
        var num = 0;
        if (typeof params == 'number')
            num = params.toFixed(2);
        else if (typeof params.value == 'number')
            num = params.value.toFixed(2);
        return num + "%";
    }
    static formatPercentageNoDecimal(params) {
        var num = 0;
        if (typeof params == 'number')
            num = Math.round(params).toFixed(2);
        else if (typeof params.value == 'number')
            num = Math.round(params.value).toFixed(2);

        return num + "%";
    }
    static formatAmount(params) {
        var num = params.value.toFixed(2);
        return "$ " + num;

    }
    static formatPhone(params) {
        var phoneNumber = params.value;
        let cleaned = ('' + phoneNumber).replace(/\D/g, '');
        let match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
        if (match) {
            return '(' + match[1] + ') ' + match[2] + '-' + match[3]
        };

        return null
    }
    static formatAmount2(params) {
        if(params && params.value)
        {
            var num = params.value.toFixed(2);
            return "$ " + Math.round(num).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
        }
        else
        {
            return "";
        }


    }
    static formatAmountWithoutRounding(params) {
        if(params && params.value)
        {
            var num = params.value.toFixed(2);
            return "$ " + num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
        }
        else
        {
            return "";
        }


    }

    static formatNumber2(params) {

        if(params.value){

            let num = params.value.toFixed(2);
            return Math.round(num).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
        }
   
    }

    static convertToString(params) {
        return params.value ? params.value.toLocaleString() : "N/A";
    }


static formatNumber(params) {
  let num = 0;

  if (typeof params === 'number') {
    num = params.toFixed(2);
  } else if (typeof params?.value === 'number') {
    num = params.value.toFixed(2);
  } else {
    return '0';
  }

  return Math.round(num)
    .toString()
    .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
}

    static formatDate(params) {
        return new Date(params.value);
    }

    static formatDatefromUTC(params) {
        if (params.value) {
            let newDate = new Date(parseInt(params.value.replace(/[^0-9 +]/g, '')));

            return newDate.toLocaleDateString();
        } else {
            return params.value;
        }

    }

    static formatDateFromUTCvNext(params) {
        if (params.value)
        {
            let year = params.value.substring(0,4);
            let month = params.value.substring(5,7);
            let day = params.value.substring(8,10);
            // construct new date object for sorting
            let newDate = new Date(year, parseInt(month)-1, day);  /* months 0..11 */
            return newDate.toLocaleDateString();
        }
        else {
            return params.value;
        }
    }

    static formatDateTimefromUTC(params) {
        if (params.value) {
            let newDate;
            if(!isNaN(Date.parse(params.value))){
                newDate = new Date(params.value);
            } else {
                newDate = new Date(parseInt(params.value.replace(/[^0-9 +]/g, '')));
            }
            return newDate.toLocaleString();
        } else {
            return params.value;
        }
    }

    static vNextformatDateTimefromUTC(params) {
        if (params.value) {
            let newDate = new Date(params.value);
            var returnDate = (newDate.getMonth() + 1).toString() + "/" + newDate.getDate().toString() + "/" + newDate.getFullYear().toString();
            return returnDate;
        } else {
            return params.value;
        }
    }

    static formatDateWithTime(params) {
        if (params.value != null && params.value !== "") {
            let newDate = new Date(params.value);
            var hours = newDate.getHours();
            var minutes = (newDate.getMinutes() < 10 ? "0" : "") + newDate.getMinutes();
            var ampm = hours >= 12 ? "PM" : "AM";
            hours = hours % 12;
            hours = hours ? hours : 12; // the hour '0' should be '12'
            var returnDate = (newDate.getMonth() + 1).toString() + "/" + newDate.getDate().toString() + "/" + newDate.getFullYear().toString() + " " + hours + ":" + minutes + " " + ampm;
            return returnDate;
        } else {
            return params.value;
        }
    }

    static formatDateWithTimeWithLineBreak(date) {
        if (date != null && date !== "") {
            let newDate = new Date(date);
            var hours = newDate.getHours();
            var minutes = (newDate.getMinutes() < 10 ? "0" : "") + newDate.getMinutes();
            var ampm = hours >= 12 ? "PM" : "AM";
            hours = hours % 12;
            hours = hours ? hours : 12; // the hour '0' should be '12'
            var dateStr = (newDate.getMonth() + 1).toString() + "/" + newDate.getDate().toString() + "/" + newDate.getFullYear().toString();
            var timeStr = hours + ":" + minutes + " " + ampm;
            // Use a div with controlled line height instead of <br/> to reduce spacing
            var returnDate = `<div style="line-height: 1.5; text-align: right; font-size: inherit;">${dateStr}<br/>${timeStr}</div>`;
            return returnDate;
        } else {
            return date;
        }
    }
}

export default GridDataFormater;